<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-toolbar class="md-success">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start">
            <hierarchy-menu></hierarchy-menu>
          </div>
        </div>
      </md-toolbar>
      <br />
    </div>

    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>power</md-icon>
          </div>
          <p class="category">{{$lang.charts.voltage}}</p>
          <h3 class="title">
            <animated-number
              :value="averageVoltage"
              :formatValue="voltageFormat"
              :duration="animationDuration"
            />
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-progress-spinner
              v-if="statisticData.loading"
              :md-diameter="15"
              :md-stroke="2"
              md-mode="indeterminate"
            ></md-progress-spinner>
            <span v-else>
              MIN
              <b>
                <animated-number
                  :value="statisticData.U.MIN"
                  :formatValue="voltageFormat"
                  :duration="animationDuration"
                />
              </b>
              | AVG
              <b>
                <animated-number
                  :value="statisticData.U.AVG"
                  :formatValue="voltageFormat"
                  :duration="animationDuration"
                />
              </b>
              | MAX
              <b>
                <animated-number
                  :value="statisticData.U.MAX"
                  :formatValue="voltageFormat"
                  :duration="animationDuration"
                />
              </b>
              {{$lang.general.per}} {{localizedDateRange()}}
            </span>
          </div>
        </template>
      </stats-card>
    </div>

    <div class="md-layout-item md-size-100">
      <global-sales-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>language</md-icon>
          </div>
          <h4 class="title">{{$lang.charts.locations}}</h4>
        </template>

        <template slot="content">
          <devices-stats-panel :settings="devicesStatsData"></devices-stats-panel>
          <!-- <div id="map"></div> -->
        </template>
      </global-sales-card>
    </div>





    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/utils/gmaps";
import { Modal } from "@/components";
import snackBar from "@/components/SnackBar";
import hierarchyMenu from "@/components/HierarchyMenu";
import AnimatedNumber from "animated-number-vue";

import chartOptions from "@/config/charts/column";
import axios from "axios";
import { getSelectedDeviceToken, getUserToken } from "@/storage/memoryStorage";

import format from "date-fns/format";
import subHours from "date-fns/sub_hours";
import subDays from "date-fns/sub_days";
import start_of_today from "date-fns/start_of_today";
import end_of_today from "date-fns/end_of_today";
import startOfWeek from "date-fns/start_of_week";
import endOfWeek from "date-fns/end_of_week";
import startOfMonth from "date-fns/start_of_month";
import endOfMonth from "date-fns/end_of_month";
import startOfYear from "date-fns/start_of_year";
import endOfYear from "date-fns/end_of_year";
import endOfTomorrow from "date-fns/end_of_tomorrow";
import startOfHour from "date-fns/start_of_hour";

import { StatsCard, GlobalSalesCard } from "@/components";
import { startOfDay, subMonths } from "date-fns";
import { types } from "util";


import DevicesStatsPanel from "@/components/Dashboard/DevicesStatsPanel";

export default {
  components: {
    "hierarchy-menu": hierarchyMenu,
    "snack-bar": snackBar,
    Modal,
    AnimatedNumber,
    StatsCard,
    GlobalSalesCard,
    SlideYDownTransition,
    DevicesStatsPanel
  },

  data() {
    return {
      animationDuration: 500,
      selectedDateRange: "",
      averageVoltage: "",
      statisticData: {
        loading: false,
        U: {
          MIN: 0,
          AVG: 0,
          MAX: 0
        }
      },

      locations: [],
      devicesStatsData: []
    };
  },

  computed: {
    WSmessage() {
      return this.$store.getters.getDataMessage;
    },
    selectedDate() {
      return this.$store.getters.getDateRange;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    deviceList() {
      return this.$store.getters.getDeviceList;
    },
    statsDate() {
      return this.$store.getters.getSettings.statsDate;
    },
    overviewStatsUpdate() {
      return this.$store.getters.getOverviewStats;
    }
  },

  watch: {
    WSmessage: function(payload, oldPayload) {
      this.averageVoltage = 0;
      if (payload.U) {
        let dividerAVG = 0;
        Object.keys(payload.U).forEach(phase => {
          const value = payload.U[phase];
          if (value > 0) {
            this.averageVoltage += value;
            dividerAVG++;
          }
        });
        this.averageVoltage = this.averageVoltage / dividerAVG;
      }
    },

    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        this.getStatisticsData();
      }
    },

    overviewStatsUpdate: function(newVal, oldVal) {
      if (newVal) {
        this.getHierarchyData();
        this.$store.commit("setOverviewStats", false);
      }
    }
  },

  created() {
    this.getHierarchyData();
    this.selectedDateRange = this.statsDate.selector;
  },

  mounted() {
    let compStatsDateRange = this.getTSFromDateRange(this.selectedDateRange);

    if (
      compStatsDateRange.from !== this.statsDate.from ||
      compStatsDateRange.to !== this.statsDate.to
    ) {
      compStatsDateRange.selector = this.selectedDateRange;
      this.$store.commit("setstatsDate", compStatsDateRange);
    }

    this.getStatisticsData();
  },

  methods: {
    localizedDateRange() {
      switch (this.selectedDateRange) {
        case "today":
          return this.$lang.keys.today_stats;
        case "week":
          return this.$lang.keys.week;
        case "month":
          return this.$lang.keys.month;
        case "year":
          return this.$lang.keys.year;
      }
    },

    getTSFromDateRange(dateRange) {
      let statDate = {
        selector: dateRange,
        from: 0,
        to: 0
      };
      switch (dateRange) {
        case "today":
          statDate.from = format(start_of_today(), "X");
          statDate.to = format(end_of_today(), "X");
          break;
        case "week":
          statDate.from = format(
            startOfWeek(start_of_today(), {
              weekStartsOn: 1
            }),
            "X"
          );
          statDate.to = format(
            endOfWeek(start_of_today(), {
              weekStartsOn: 1
            }),
            "X"
          );
          break;
        case "month":
          statDate.from = format(startOfMonth(start_of_today()), "X");
          statDate.to = format(endOfMonth(start_of_today()), "X");
          break;
        case "year":
          statDate.from = format(startOfYear(start_of_today()), "X");
          statDate.to = format(endOfYear(start_of_today()), "X");
          break;
      }
      return statDate;
    },

    getStatisticsData() {
      this.statisticData.loading = true;
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/statistics",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          data: "U",
          statData: "MIN,MAX,AVG",
          phase: "L1",
          from: this.statsDate.from,
          to: this.statsDate.to
        },
        withCredentials: true
      })
        .then(response => {
            this.statisticData.U.MIN = response.data.data.U.L1.MIN;
            this.statisticData.U.AVG = response.data.data.U.L1.AVG;
            this.statisticData.U.MAX = response.data.data.U.L1.MAX;

            this.statisticData.loading = false;
        })
        .catch(error => {
          if (error.response) {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    getHierarchyData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/facility/devices-hierarchy",
        data: {
          token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.tags.forEach(element => {
            if (
              element.hasOwnProperty("lat") &&
              element.hasOwnProperty("lng")
            ) {
              const deviceListIndex = this.deviceList.findIndex(
                e => e.mac == element.mac
              );

              const mapMarker = {
                position: {
                  lat: Number(element.lat),
                  lng: Number(element.lng)
                },
                data: {
                  title: element.title,
                  tag: element.tags[0],
                  mac: element.mac,
                  status: this.deviceList[deviceListIndex].status
                }
              };

              this.locations.push(mapMarker);
            }
            if (element.tags.length > 0) {
              this.devicesStatsData.push(element.tags[0]);
            }
          });
          //this.initMap();
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code != 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
          //this.initMap();
        });
    },

    voltageFormat(value) {
      return `${Number(value).toFixed(1)} V`;
    },

    // async initMap() {
    //   try {
    //     const google = await gmapsInit();
    //     const geocoder = new google.maps.Geocoder();
    //     const map = new google.maps.Map(document.getElementById("map"), {
    //       gestureHandling: "cooperative"
    //     });

    //     function placeMarkerAndPanTo(latLng, map) {
    //       var marker = new google.maps.Marker({
    //         position: latLng,
    //         map: map
    //       });
    //       map.panTo(latLng);
    //     }

    //     geocoder.geocode({ address: `Slovakia` }, (results, status) => {
    //       if (status !== `OK` || !results[0]) {
    //         throw new Error(status);
    //       }

    //       map.setCenter(results[0].geometry.location);
    //       map.fitBounds(results[0].geometry.viewport);
    //     });

    //     /*        adding tag by click
    //      map.addListener("click", function(e) {
    //       placeMarkerAndPanTo(e.latLng, map);
    //     }); */

    //     const markerClickHandler = marker => {
    //       map.setZoom(18);
    //       map.setCenter(marker.getPosition());

    //       var contentString =
    //         '<div id="content">' +
    //         '<div id="siteNotice">' +
    //         "</div>" +
    //         '<h4 id="firstHeading" class="firstHeading">' +
    //         marker.data.title +
    //         "</h4>" +
    //         '<div id="bodyContent">' +
    //         this.$lang.general.device +
    //         ": " +
    //         marker.data.tag +
    //         "</br>" +
    //         "MAC: " +
    //         marker.data.mac +
    //         "</br>" +
    //         this.$lang.general.status +
    //         ": " +
    //         marker.data.status +
    //         "</br>" +
    //         "</div>" +
    //         "</div>";

    //       var infowindow = new google.maps.InfoWindow({
    //         content: contentString
    //       });

    //       infowindow.open(map, marker);
    //     };

    //     const markers = this.locations.map(location => {
    //       const marker = new google.maps.Marker({ ...location, map });
    //       marker.addListener(`click`, () => markerClickHandler(marker));

    //       return marker;
    //     });

    //     /*       new MarkerClusterer(map, markers, {
    //     imagePath: `https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m`,
    //   }); */
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }
  }
};
</script>

<style scoped>
#map {
  margin: 0;
  max-height: 500px;
}

.normal-header {
  padding: 0 !important;
  min-height: 0px;
}

/* .md-button.md-simple i,
.md-button.md-simple:hover i {
  color: #ffffff !important;
} */

.md-toolbar {
  position: inherit;
}

.modal-header {
  opacity: 1;
}

.card-title {
  margin: 10px;
}

.modal-body {
  padding: 0px 0px 16px;
}

.modal-body p {
  margin: 5px;
}

.dashboardChart {
  height: 350px;
}
</style>
